import styled from "styled-components";
import { FontMixin } from "../../../../styles/common/mixins/helpers.styled.js";
import calendarThemes from "./themes/index.js";
export const CalendarWrapper = styled.div.withConfig({
    displayName: "styled__CalendarWrapper",
    componentId: "sc-79d7761-0"
})`
	position: relative;
	width: 100%;
`;
export const CalendarLabel = styled.label.withConfig({
    displayName: "styled__CalendarLabel",
    componentId: "sc-79d7761-1"
})`
	top: 8px;
	color: ${({ theme  })=>theme.colors.grays.base};
	position: absolute;
	pointer-events: none;
	${FontMixin({
    size: 'small',
    height: 'small',
    weight: 'regular'
})}
	padding-left: 12px;
	transition: all 0.2s linear;

	${({ theme  })=>calendarThemes[theme.id]?.CalendarLabel?.()}
`;
export const CalendarInputIcon = styled.div.withConfig({
    displayName: "styled__CalendarInputIcon",
    componentId: "sc-79d7761-2"
})`
	box-sizing: border-box;
	color: ${({ theme  })=>theme.colors.grays.base};
	${FontMixin({
    size: 'large',
    height: 'large',
    weight: 'light'
})}
	margin: 0;
	padding: 0;
	pointer-events: none;
	position: absolute;
	right: 12px;
	top: calc(50% - 12px);

	${({ theme  })=>calendarThemes[theme.id]?.CalendarInputIcon?.()}
`;

//# sourceMappingURL=styled.js.map